import API, { initApiUrl } from '@/store/api'
import API2, { initApiUrl as initApi2Url } from '@/store/api2'
import { ofOrderRequest } from '@/models/PreOrder/OrderRequest'
import { ofCoupon } from '@/models/PreOrder/Coupon'
import ResultSet from '@/models/Common/ResultSet'
import { ofDeliveryReservationOptionsResponse } from '@/models/PreOrder/DeliveryReservationOptionsResponse'
import PersonalState from '@/presentationals/v2/components/layouts/organisms/PreOrderCashReceipt/states/PersonalState'
import BusinessState from '@/presentationals/v2/components/layouts/organisms/PreOrderCashReceipt/states/BusinessState'
import { isProvideBaeminPoint } from '../../config/featureProvider'

initApiUrl('') // TODO 확인; API 사용시 마다 필요?
initApi2Url(process.env.VUE_APP_PROXY_API_URL_2)

const preOrder = {
  namespaced: true,
  state: {
    shopId: null,
    orderSheetKey: null,
    includeReturnOrExchangeProduct: false,
    products: [],
    delivery: {
      address: null,
      roadAddress: null,
      detailAddress: null,

      phoneNumber: null,
      useSafePhoneNumber: true, // true 고정

      memo: null
    },
    deliveryReservation: {
      active: false,
      use: false,
      selected: {},
      options: []
    },

    price: {
      orderPrice: 0, // itemPrice
      deliveryFee: 0, // levyDeliveryCharge
      deliveryChargeBeforeDiscount: 0
    },
    cartDiscount: {
      id: null,
      amount: 0
    },
    coupon: {
      use: false,
      selected: [],
      options: []
    },
    baeminPoint: {
      use: false,
      spentAmount: null,
      availableAmount: 0
    },
    giftCards: {
      use: false,
      cards: []
    },
    selectedGiftCards: [],
    invalidGiftCards: [],
    paymentNotices: [],
    paymentMethod: {
      code: '1',
      displayName: '신용/체크카드',
      promotion: '',
      availableCashReceipt: false,
      availableGuest: false,
      default: true,
      disable: false,
      disableDescription: ''
    },
    paymentMethodOptions: [],
    firstOrder: false,
    terms: {
      deliveryCaution: null,
      etf: null,
      policy: null,
      service: null,
      thirdParty: null,
      thirdPartyNon: null
    },

    // TODO move user
    certification: {
      needs: false,
      url: null
    },

    cashReceiptNumber: '',

    recentCashReceipt: {
      save: false,
      issue: false,
      type: 'PERSONAL',
      number: null
    },

    cashReceiptType: [
      {
        type: 'PERSONAL',
        title: '개인 소득공제용',
        component: PersonalState
      },
      {
        type: 'BUSINESS',
        title: '사업자 증빙용',
        component: BusinessState
      }
    ],

    cashReceipt: {
      showCashReceipt: false,
      alert: false,
      alertMessage: null,
      approvalDateTime: null,
      status: null,
      typeName: null,
      issuanceAmount: 0,
      issuanceNumber: null,
      approvalNumber: null,
      corporateName: null,
      corporateNumber: null
    },

    paymentMethodModal: {
      isOpen: false
    },
    afid: null,
    adid: null,
    shopMessage: ''
  },
  mutations: {
    setPaymentMethodModal: (state, paymentMethod) => {
      state.paymentMethodModal = {
        ...state.paymentMethodModal,
        ...paymentMethod
      }
    },

    setOrderSheetKey: (state, orderSheetKey) => {
      state.orderSheetKey = orderSheetKey
    },
    setByOrderSheet: (state, payload) => {
      const { products, delivery, paymentMethod, price, cartDiscount, includeReturnOrExchangeProduct } = payload

      state.products = products
      state.shopId = products[0].items[0].shopId

      state.includeReturnOrExchangeProduct = includeReturnOrExchangeProduct

      state.delivery = {
        ...state.delivery,
        ...{
          phoneNumber: delivery.phone,
          address: delivery.address
        }
      }

      state.price = {
        ...state.price,
        orderPrice: price.itemPrice, // 총 주문 금액
        deliveryFee: price.levyDeliveryCharge, // 총 배달팁 금액
        deliveryChargeBeforeDiscount: price.deliveryChargeBeforeDiscount
      }

      state.cartDiscount = {
        ...state.cartDiscount,
        ...cartDiscount
      }
    },
    setDelivery(state, payload) {
      state.delivery = {
        ...state.delivery,
        ...payload
      }
    },
    setDeliveryReservation(state, payload) {
      state.deliveryReservation = {
        ...state.deliveryReservation,
        ...payload
      }
    },
    // FIXME state 구조변경에 의해 변경 필요
    setCoupon(state, payload) {
      state.coupon = {
        ...state.coupon,
        use: !!payload,
        selected: !payload ? [] : [payload]
      }
    },
    resetGiftCards(state) {
      state.giftCards = {
        use: true,
        cards: []
      }
    },
    setSelectedGiftCards(state, giftCard) {
      state.selectedGiftCards = [...giftCard]
    },
    // FIXME state 구조변경에 의해 변경 필요
    setCouponOptions(state, payload) {
      state.coupon = {
        ...state.coupon,
        options: [...payload]
      }
    },
    setPaymentMethod(state, payload) {
      state.paymentMethod = {
        ...state.paymentMethod,
        ...payload
      }
    },
    setPaymentMethodOptions(state, methodOptions) {
      state.paymentMethodOptions = methodOptions
    },
    setFirstOrder(state, firstOrder) {
      state.firstOrder = firstOrder || false
    },
    setTerms(state, payload) {
      state.terms = {
        ...state.terms,
        ...payload
      }
    },

    setCertification(state, payload) {
      state.certification = {
        ...state.certification,
        ...payload
      }
    },

    setCashReceiptNumber(state, number) {
      state.cashReceiptNumber = number
    },

    setCashReceipt(state, cashReceipt) {
      state.cashReceipt = {
        ...state.cashReceipt,
        ...cashReceipt
      }
    },

    setRecentCashReceipt(state, recentCashReceipt) {
      state.recentCashReceipt = {
        ...state.recentCashReceipt,
        ...recentCashReceipt
      }
    },

    setAppsFlyerIds(state, ids) {
      const { afid, adid } = ids
      state.afid = afid
      state.adid = adid
    },

    setBaeminPoint(state, baeminPoint) {
      state.baeminPoint = {
        ...state.baeminPoint,
        ...baeminPoint
      }
    },

    setGiftCards(state, result) {
      if (!result) {
        state.giftCards = null
        return
      }

      const { cards: giftCards, active } = result

      if (!giftCards) {
        return
      }

      const mappedGiftCards = giftCards.map((giftCard, index) => {
        return {
          ...giftCard,
          priority: index
        }
      })

      state.giftCards = {
        use: active || false,
        cards: [...state.giftCards.cards, ...mappedGiftCards]
      }
    },

    setInvalidGiftCards(state, giftCards) {
      state.invalidGiftCards = [...giftCards]
    },

    setPaymentNotices(state, paymentNotices) {
      state.paymentNotices = [...paymentNotices]
    },
    setShopMessage: (state, payload) => {
      state.shopMessage = payload
    }
  },
  getters: {
    paymentMethodModal: (state) => state.paymentMethodModal,
    shopId: (state) => state.shopId,
    orderSheetKey: (state) => state.orderSheetKey,
    products: (state) => state.products,
    delivery: (state) => state.delivery,
    deliveryReservation: (state) => state.deliveryReservation,
    availableDeliveryReservation: (state) =>
      state.deliveryReservation.active && _.some(state.deliveryReservation.options, (e) => e.active),
    price: (state) => state.price,
    cartDiscount: (state) => state.cartDiscount,
    coupon: (state) => state.coupon,
    baeminPoint: (state) => state.baeminPoint,
    paymentNotices: (state) => state.paymentNotices,
    paymentMethod: (state) => state.paymentMethod,
    paymentMethodOptions: (state) => state.paymentMethodOptions,
    firstOrder: (state) => state.firstOrder,
    terms: (state) => state.terms,
    giftCards: (state) => state.giftCards,
    selectedGiftCards: (state) => state.selectedGiftCards,
    invalidGiftCards: (state) => state.invalidGiftCards,

    totalPaymentPrice: (state) => {
      const orderPrice = state.price.orderPrice || 0
      const deliveryPrice = state.price.deliveryFee || 0
      const cartDiscountPrice = state.cartDiscount.amount || 0
      const couponPrice = state.coupon.selected.reduce((acc, cur) => {
        let { amount } = cur
        if (cur.type === 'DELIVERY' && cur.amount > deliveryPrice) {
          amount = deliveryPrice
        }

        if (cur.type === 'BASKET') {
          if (cur.displayCatalogIds.length === 0 && cur.displayProductIds.length === 0) {
            // catalogId, productId 해당 없을때
            if (cur.amount > orderPrice) {
              amount = orderPrice
            }
          } else if (cur.displayCatalogIds.length === 0) {
            const filteredProducts = state.products.filter((product) =>
              cur.displayProductIds.includes(product.productId)
            )

            const filteredTotalitems = filteredProducts.reduce((itemAcc, itemCur) => [...itemAcc, ...itemCur.items], [])

            const totalPrice = filteredTotalitems.reduce((acc, cur) => acc + cur.unitPrice * cur.quantity, 0)

            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          } else if (cur.displayProductIds.length === 0) {
            const filteredProducts = state.products.filter((product) =>
              cur.displayCatalogIds.some((id) => product.catalogIds.includes(id))
            )

            const filteredTotalitems = filteredProducts.reduce((itemAcc, itemCur) => [...itemAcc, ...itemCur.items], [])
            const totalPrice = filteredTotalitems.reduce((acc, cur) => acc + cur.unitPrice * cur.quantity, 0)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          } else {
            const filteredProducts = state.products.filter(
              (product) =>
                cur.displayCatalogIds.some((id) => product.catalogIds.includes(id)) ||
                cur.displayProductIds.includes(product.productId)
            )

            const filteredTotalitems = filteredProducts.reduce((itemAcc, itemCur) => [...itemAcc, ...itemCur.items], [])
            const totalPrice = filteredTotalitems.reduce((acc, cur) => acc + cur.unitPrice * cur.quantity, 0)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          }
        }

        acc += amount
        return acc
      }, 0)

      const giftCartSpentPrice = state.selectedGiftCards.reduce((acc, curr) => {
        return acc + curr.spentAmount
      }, 0)

      const baeminPointSpentPrice = state.baeminPoint.spentAmount

      return orderPrice + deliveryPrice - (cartDiscountPrice + couponPrice + baeminPointSpentPrice + giftCartSpentPrice)
    },
    includeReturnOrExchangeProduct: (state) => state.includeReturnOrExchangeProduct,

    certification: (state) => state.certification,

    recentCashReceipt: (state) => state.recentCashReceipt,
    cashReceiptType: (state) => state.cashReceiptType,
    cashReceipt: (state) => state.cashReceipt,
    cashReceiptNumber: (state) => state.cashReceiptNumber,
    shopMessage: (state) => state.shopMessage
  },
  actions: {
    openPaymentMethod: async ({ commit }) => {
      commit('setPaymentMethodModal', {
        isOpen: true
      })
    },
    closePaymentMethod: async ({ commit }) => {
      commit('setPaymentMethodModal', {
        isOpen: false
      })
    },
    loadPreOrderSheet: async ({ commit, rootState }, { orderSheetKey }) => {
      commit('setOrderSheetKey', orderSheetKey)

      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key,
          'SESSION-ID': rootState.user.authorization.sessionId,
          Authorization: `Bearer ${rootState.user.authorization.accessToken}`
        }
      }

      const shopMessageResp = await API.get('/v1/main/shop/message', option)
      if (shopMessageResp.code !== '200' || shopMessageResp.failed) {
        return ResultSet.fail(shopMessageResp)
      }

      commit('setShopMessage', shopMessageResp.result.footer)

      // TODO check src/views/order/PreOrderV2.vue:228
      const { failed, message, result } = await API.get(`/v1/orders/sheet/${orderSheetKey}`)
      if (failed)
        return ResultSet.fail({
          message
        })

      const { sheet: orderSheet } = result

      commit('setByOrderSheet', orderSheet, {
        root: true
      })
      commit('setByOrderSheet', orderSheet)

      // TODO implement app log: addPurchaseViewLog

      // TODO 운영 데이터 연동으로 수정
      commit('setPaymentMethodOptions', orderSheet.paymentMethods)
      // commit('setPaymentMethodOptions', PaymentMethodOptionsMock)
      commit(
        'setPaymentMethod',
        orderSheet.paymentMethods.find((payment) => payment.default === true)
      )

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderOrderer: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      // TODO check src/views/order/PreOrderV2.vue:132
      const { failed, message, result } = await API.get('/v1/orders/orderer/one', option)
      if (failed) {
        commit('setSignedUser', false, {
          root: true
        })
        return ResultSet.fail({
          message
        })
      }

      const { email: userEmail, mobileNumber: phoneNumber, name: userName } = result

      // if (!userEmail) commit('setSignedUser', false, { root: true })
      commit('setSignedUser', !!userEmail, {
        root: true
      })

      commit('setUserName', userName, {
        root: true
      })
      commit('setUserEmail', userEmail, {
        root: true
      })
      commit('setDelivery', {
        phoneNumber
      })

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderRecentDelivery: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }
      // TODO check src/views/order/PreOrderV2.vue:145
      const { failed, message, result } = await API.get('/v1/orders/delivery/recent/first', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      commit('setDelivery', {
        memo: result.memo
      })

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderFirstOrder: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }
      // TODO check src/views/order/PreOrderV2.vue:156
      const { failed, message, result } = await API.get('/v1/orders/first', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      commit('setFirstOrder', result.isFirstOrder)

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderRecentPaymentMethod: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }
      // TODO check src/views/order/PreOrderV2.vue:168
      if (!rootState.user.isSign) return false

      const { failed, message, result } = await API.get('/v1/payment/method/recent/first', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      let recentMethod = rootState.preOrder.paymentMethodOptions.find((method) => method.codeName === result.name)
      recentMethod.baeminpay = {
        pocketNo: result.pocketNo
      }

      if (recentMethod.codeName === 'BAEMINPAY_BANK' || recentMethod.codeName === 'BAEMINPAY_CARD') {
        const { failed, message, result } = await API.get(
          `/baeminpay/v1/users/${rootState.user.baeminMemberNo}/pockets`
        )

        // 선택된 포켓
        let selectedPocket = null

        // API 응답값이 있고, 포켓 리스트가 있을 때
        if (!!result && !!result.list) {
          // bookmark가 ON 인 아이템 찾기
          const findBookmarkPocket = result.list.find((pocket) => pocket.bookmark === 'ON')

          // 찾았으면 해당 포켓이 최우선순위 주결제수단
          if (findBookmarkPocket) selectedPocket = findBookmarkPocket
          else {
            // 없으면 기존 로직 재생
            // 최근 결제수단의 포켓 넘버와 리스트 상의 포켓넘버 확인
            selectedPocket = result.list.find((pocket) => {
              return pocket.pocketNo === recentMethod.baeminpay.pocketNo
            })
          }
        }

        // 선택된 포켓이 없다면
        if (!selectedPocket) {
          // 기본 결제수단의 기본 선택 수단으로 변경
          recentMethod = rootState.preOrder.paymentMethodOptions.find((method) => method.default)
        } else {
          // 포켓이 있다면
          // 최근 메소드를 해당 포켓에 맞는 결제수단으로 변경
          const { financialCode, pocketNo } = selectedPocket

          const financialType = financialCode.includes('CARD') ? 'CARD' : financialCode.includes('BANK') ? 'BANK' : null

          if (!!financialType) {
            const resultMethod = rootState.preOrder.paymentMethodOptions.find(
              (method) => method.codeName === `BAEMINPAY_${financialType}`
            )
            resultMethod.baeminpay = {
              pocketNo
            }

            recentMethod = resultMethod
          }
        }
      }

      commit('setPaymentMethod', recentMethod)

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderPaymentMethodOptions: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      // TODO cheeck src/views/order/PreOrderV2.vue:183
      const { failed, message, result } = await API.get('/v1/payment/method/available', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderTerms: async ({ commit }) => {
      // TODO check src/components/order/Terms.vue:53
      const { failed, message, result } = await API.get('/v1/orders/term')
      if (failed)
        return ResultSet.fail({
          message
        })

      commit('setTerms', result)

      return ResultSet.ok({
        result
      })
    },

    loadPreOrderRecentCashReceipt: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'USER-BAEDAL': rootState.user.authorization.key
        }
      }

      const { failed, message, result } = await API.get('/v1/orders/payment/cash-receipt/recent/first', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      if (!result.number) result.number = ''
      commit('setRecentCashReceipt', result)
      commit('setCashReceiptNumber', result.number)

      return ResultSet.ok({
        result
      })
    },

    // src/components/order/OrderButton.vue:129
    loadUserCertification: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        },
        params: {
          key: rootState.preOrder.orderSheetKey
        }
      }

      // TODO check $http 별도 클라이언트 사용 src/components/order/OrderButton.vue:130
      const { failed, message, result } = await API.get('/v1/members/certificate', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      commit('setCertification', {
        needs: result.needsCertification,
        url: result.certificationUrl
      })

      return ResultSet.ok({
        result
      })
    },

    loadDeliveryReservationOptions: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const { shopId } = rootState.preOrder
      const { failed, message, result } = await API.get(`/v1/reservation/available/time/by/${shopId}`, option)
      if (failed)
        return ResultSet.fail({
          message
        })

      const deliveryReservationOptionsResponse = ofDeliveryReservationOptionsResponse(result)
      commit('setDeliveryReservation', {
        active: deliveryReservationOptionsResponse.reservationAvailable,
        options: deliveryReservationOptionsResponse.getDisplayTimes()
      })

      return ResultSet.ok({
        result
      })
    },

    loadCoupons: async ({ commit, rootState }) => {
      const orderAmount = rootState.preOrder.price.orderPrice || 0
      const deliveryAmount = rootState.preOrder.price.deliveryFee || 0
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
        // params: { orderAmount, deliveryAmount } // 주문금액 - 즉시할인; 배달팁 미포함
      }

      const { shopId, products, orderSheetKey } = rootState.preOrder

      const params = {
        orderSheetId: orderSheetKey,
        orderAmount,
        deliveryAmount,
        shopId,
        products: products.reduce((acc, curr) => {
          acc.push({
            id: curr.productId,
            catalogIds: curr.catalogIds || [],
            items: curr.items.map((item) => ({
              id: item.itemId,
              quantity: item.quantity,
              amount: item.unitPrice
            }))
          })

          return acc
        }, [])
      }

      // TODO remove dev code
      // const { failed, message, result } = await API.get('/v1/coupon/issuance/available/order', option)
      // const { failed, message, result } = {
      //   code: '200',
      //   success: true,
      //   failed: false,
      //   message: null,
      //   result: CouponIssuanceAvailableOrderResponseJson
      // }

      const { failed, message, result, code } = await API2.post('/v1/coupon/issuance/available/order', params, option)
      if (failed)
        return ResultSet.fail({
          message: code / 500 >= 1 ? '쿠폰 정보를 찾을 수 없습니다. 다음에 이용해주세요.' : message
        })

      commit('setCouponOptions', [
        ...result.availableCoupons.map((e) =>
          ofCoupon({
            ...e,
            available: true
          })
        ),
        ...result.unavailableCoupons.map((e) => ofCoupon(e))
      ])

      return ResultSet.ok({
        result
      })
    },

    loadBaeminPoint: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const { failed, message, result } = await API.get('/v1/points/available', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      commit('setBaeminPoint', {
        availableAmount: result.amount
      })

      return ResultSet.ok({
        result
      })
    },

    loadGiftCard: async ({ commit, rootState }) => {
      if (!rootState.user.isSign) {
        return
      }

      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const { failed, message, result } = await API.get('/v1/giftcard/available', option)
      if (failed) {
        commit('setGiftCards', null)
        return ResultSet.fail({
          message
        })
      }

      commit('setGiftCards', result)

      return ResultSet.ok({
        result
      })
    },

    loadPaymentNotice: async ({ commit, rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const { failed, message, result } = await API.get('/v1/payment/notices', option)
      if (failed)
        return ResultSet.fail({
          message
        })

      // TODO API 에서 subMessage 필드 추가되었는지 확인 필요
      commit('setPaymentNotices', [
        ...result.notices.map((notice) => ({
          ...notice
        }))
      ])

      return ResultSet.ok({
        result
      })
    },

    doGiftCardValidate: async ({ rootState }, { appliedGiftCards }) => {
      const refinedGiftCardsData = appliedGiftCards.map((giftCard) => ({
        giftcardNumber: giftCard.giftcardNumber,
        amount: giftCard.spentAmount
      }))

      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const validateData = {
        list: refinedGiftCardsData
      }
      const { failed, message, result } = await API.post('/v1/giftcard/valid', validateData, option)
      if (failed)
        return ResultSet.fail({
          message
        })

      return ResultSet.ok({
        result
      })
    },

    doPayment: async ({ rootState, getters }) => {
      const { codeName, availableCashReceipt, baeminpay } = rootState.preOrder.paymentMethod
      const { type, issue, save } = rootState.preOrder.recentCashReceipt
      const selectedGiftCardsExist = rootState.preOrder.selectedGiftCards.length > 0

      const paymentDetailAmount = getters.totalPaymentPrice

      const paymentMethod = {
        payMethod: codeName,
        pocketToken: baeminpay ? baeminpay.pocketNo : null
      }

      const showCashReceipt = availableCashReceipt || selectedGiftCardsExist

      const cashReceipt = {
        cashReceiptType: showCashReceipt && issue ? type : null,
        cashReceiptNumber: showCashReceipt && issue ? rootState.preOrder.cashReceiptNumber.replace(/ /gi, '') : null,
        issueCashReceipt: showCashReceipt && issue ? issue : false,
        saveCashReceipt: showCashReceipt && issue ? save : false
      }

      const provideBaeminPoint = isProvideBaeminPoint({
        isSign: rootState.user.isSign,
        includeReturnOrExchangeProduct: rootState.preOrder.includeReturnOrExchangeProduct
      })

      const subPaymentMethods =
        provideBaeminPoint && rootState.preOrder.baeminPoint.spentAmount > 0
          ? [
              {
                payMethod: 'BAEMIN_POINT',
                amount: rootState.preOrder.baeminPoint.spentAmount || 0
              }
            ]
          : []

      const couponDiscounts = rootState.preOrder.coupon.selected.reduce((acc, cur) => {
        const coupon = cur.toRequest()

        if (cur.type === 'DELIVERY' && cur.amount > rootState.preOrder.price.deliveryFee) {
          coupon.amount = rootState.preOrder.price.deliveryFee
        }

        if (cur.type === 'BASKET') {
          if (cur.displayCatalogIds.length === 0 && cur.displayProductIds.length === 0) {
            // catalogId, productId 해당 없을때
            if (cur.amount > rootState.preOrder.price.orderPrice) {
              coupon.amount = rootState.preOrder.price.orderPrice
            }
          } else if (cur.displayCatalogIds.length === 0) {
            const filteredProducts = rootState.preOrder.products.filter((product) =>
              cur.displayProductIds.includes(product.productId)
            )

            const filteredTotalitems = filteredProducts.reduce((itemAcc, itemCur) => [...itemAcc, ...itemCur.items], [])

            const totalPrice = filteredTotalitems.reduce((acc, cur) => acc + cur.unitPrice * cur.quantity, 0)

            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            coupon.amount = saleCouponPrice
          } else if (cur.displayProductIds.length === 0) {
            const filteredProducts = rootState.preOrder.products.filter((product) =>
              cur.displayCatalogIds.some((id) => product.catalogIds.includes(id))
            )

            const filteredTotalitems = filteredProducts.reduce((itemAcc, itemCur) => [...itemAcc, ...itemCur.items], [])
            const totalPrice = filteredTotalitems.reduce((acc, cur) => acc + cur.unitPrice * cur.quantity, 0)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            coupon.amount = saleCouponPrice
          } else {
            const filteredProducts = rootState.preOrder.products.filter(
              (product) =>
                cur.displayCatalogIds.some((id) => product.catalogIds.includes(id)) ||
                cur.displayProductIds.includes(product.productId)
            )

            const filteredTotalitems = filteredProducts.reduce((itemAcc, itemCur) => [...itemAcc, ...itemCur.items], [])
            const totalPrice = filteredTotalitems.reduce((acc, cur) => acc + cur.unitPrice * cur.quantity, 0)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            coupon.amount = saleCouponPrice
          }
        }

        acc.push(coupon)
        return acc
      }, [])

      let discountAmount = couponDiscounts.reduce((acc, curr) => {
        acc += curr.amount
        return acc
      }, 0)

      discountAmount += rootState.preOrder.cartDiscount.amount > 0 ? rootState.preOrder.cartDiscount.amount : 0

      const noPaymentMethod = paymentDetailAmount === 0
      const useCoupon = discountAmount > 0
      const useBaeminPoint = rootState.preOrder.baeminPoint.spentAmount > 0

      const paymentDetail = noPaymentMethod
        ? useCoupon
          ? useBaeminPoint
            ? {
                amount: 0
              }
            : {
                amount: 0,
                ...paymentMethod
              }
          : {
              amount: 0
            }
        : {
            amount: paymentDetailAmount,
            ...paymentMethod
          }

      const order = ofOrderRequest({
        sheetKey: rootState.preOrder.orderSheetKey,

        accessToken: rootState.user.authorization.accessToken,
        userName: rootState.user.userName,
        userEmail: rootState.user.userEmail,

        sessionId: rootState.user.authorization.sessionId,
        afid: rootState.preOrder.afid,
        adid: rootState.preOrder.adid,
        baeminGiftcards: {
          cardUsages: rootState.preOrder.selectedGiftCards.map((giftCard) => ({
            giftcardNumber: giftCard.giftcardNumber,
            amount: giftCard.spentAmount
          }))
        },
        cashReceipt,

        amount: rootState.preOrder.price.orderPrice,
        deliveryCharge: rootState.preOrder.price.deliveryFee,
        discountAmount, // API 협의; 0 으로 고정
        products: rootState.preOrder.products.reduce((iter, product) => {
          const newProducts = product.items.map((item) => ({
            productId: product.productId,
            catalogIds: product.catalogIds || [],
            cartItemId: item.cartItemId,
            item: {
              id: item.itemId,
              quantity: item.quantity,
              salePrice: item.unitPrice,
              supplyPrice: item.supplyPrice,
              multiplier: item.multiplier
            }
          }))

          iter = [...iter, ...newProducts]

          return iter
        }, []),
        options: rootState.preOrder.products.reduce((acc, curr) => {
          const target = curr.options || []

          const options = target
            .filter((option) => option.quantity > 0)
            .map((option) => ({
              productId: option.productId,
              itemId: option.itemId,
              quantity: option.quantity
            }))

          acc = [...acc, ...options]
          return acc
        }, []),
        paymentDetail,
        subPaymentMethods,
        shopId: rootState.preOrder.shopId,
        phoneNumber: rootState.preOrder.delivery.phoneNumber,
        deliveryMemo: rootState.preOrder.delivery.memo,
        // useDeliveryMemoSave: rootState.preOrder.delivery.useMemoSave, // TODO https://jira.woowa.in/browse/MARKETENG-2979
        deliveryAddress: {
          address: rootState.preOrder.delivery.address,
          roadAddress: rootState.preOrder.delivery.roadAddress,
          detailAddress: rootState.preOrder.delivery.detailAddress
        },
        useSafeNumber: rootState.preOrder.delivery.useSafePhoneNumber,
        cartDiscount: rootState.preOrder.cartDiscount.amount > 0 ? rootState.preOrder.cartDiscount : null,
        couponDiscounts,

        reservation: rootState.preOrder.deliveryReservation.use,
        promiseDeliveryHour: rootState.preOrder.deliveryReservation.use
          ? rootState.preOrder.deliveryReservation.selected.fromHour
          : null,
        promiseDeliveryMinute: rootState.preOrder.deliveryReservation.use
          ? rootState.preOrder.deliveryReservation.selected.fromMinute
          : null,
        promiseDeliveryLimitHour: rootState.preOrder.deliveryReservation.use
          ? rootState.preOrder.deliveryReservation.selected.toHour
          : null,
        promiseDeliveryLimitMinute: rootState.preOrder.deliveryReservation.use
          ? rootState.preOrder.deliveryReservation.selected.toMinute
          : null
      })

      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const { failed, message, result, errorCode } = await API.post('/v1/orders', order, option)
      if (failed)
        return ResultSet.fail({
          message,
          errorCode
        })

      return ResultSet.ok({
        result
      })
    }
  }
}

export default preOrder
